import { render } from "./Spinner.vue.ts?vue&type=template&id=c4d5b2c1&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Spinner.vue?vue&type=template&id=c4d5b2c1&scoped=true&ts=true"
import script from "./Spinner.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue.scss?vue&type=style&index=0&id=c4d5b2c1&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Spinner.vue?vue&type=style&index=0&id=c4d5b2c1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d5b2c1"],['__file',"src/apps/merchant3/shared-components/ui/Spinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4d5b2c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4d5b2c1', __exports__)) {
    api.reload('c4d5b2c1', __exports__)
  }
  
  module.hot.accept("./Spinner.vue.ts?vue&type=template&id=c4d5b2c1&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Spinner.vue?vue&type=template&id=c4d5b2c1&scoped=true&ts=true", () => {
    api.rerender('c4d5b2c1', render)
  })

}


export default __exports__